import pagination from '@iso/lib/helpers/pagination';

const {
    actions: baseActions,
    types,
    reducer,
} = pagination('paymentMethods');

const actions = {
    requestFetchPaymentMethods: baseActions.request,
    fetchPaymentMethodsSucceeded: baseActions.succeeded,
    fetchPaymentMethodsFailed: baseActions.failed,
};

export { types, actions };

export default reducer;